import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * Creates a preview URL from a PDF ArrayBuffer.
 * - On native (iOS/Android): writes to a temp file and returns a file:// URL
 * - On web: creates a blob URL
 */
export async function createPdfPreviewUrl(
  pdfBuffer: ArrayBuffer,
): Promise<string> {
  const platform = Capacitor.getPlatform();

  if (platform === 'ios' || platform === 'android') {
    // Native: Write to temp file (blob URLs don't work with native PDF viewers)
    const base64 = arrayBufferToBase64(pdfBuffer);
    const fileName = `preview-${Date.now()}.pdf`;
    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64,
      directory: Directory.Cache,
    });
    return result.uri;
  }

  const pdfBlob = new Blob([pdfBuffer], { type: 'application/pdf' });
  return URL.createObjectURL(pdfBlob);
}

/**
 * Cleans up a preview URL created by createPdfPreviewUrl.
 * Only revokes blob URLs; file:// URLs in Cache are auto-cleaned by the OS.
 */
export function revokePdfPreviewUrl(url: string): void {
  if (url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}
